<template>
	<div
		:class="[
			'company-information-card-edit',
			localData.isPrimary && 'is-primary'
		]"
		:value="value"
	>
		<Radiobutton
			labelText="Set as primary"
			v-model="localData.isPrimary"
			:isActive="localData.isPrimary"
			name="CompanyContactInformation"
		/>

		<div class="company-information-card-edit__field">
			<Dropdown
				label="Phone"
				v-model="localData.phoneType"
				:options="phoneTypeOptions"
			/>
			<Input v-model="localData.phoneNumber" />
		</div>

		<div class="company-information-card-edit__field-group">
			<Dropdown
				label="Department"
				v-model="localData.department"
				:options="departmentTypeOptions"
			/>
			<Button
				v-if="!localData.isPrimary"
				className="btn--icon-only"
				iconClassName="icon-delete-glenn"
				:iconBeforeLabel="true"
			/>
		</div>
	</div>
</template>

<script>
import Radiobutton from '@/components/forms/selection-control/radiobutton/radiobutton';
import Input from '@/components/forms/input/input';
import Button from '@/components/forms/button/button';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import _ from 'lodash';

export default {
	name: 'CompanyAddressCardEdit',
	components: { Radiobutton, Input, Dropdown, Button },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			phoneTypeOptions: [
				{ text: 'Phone', value: 'P' },
				{ text: 'Fax', value: 'F' }
			],
			departmentTypeOptions: [
				{ text: 'Service', value: 'S' },
				{ text: 'Parts', value: 'P' },
				{ text: 'Main', value: 'M' },
				{ text: 'Body Shop', value: 'B' },
				{ text: 'Accounting', value: 'A' },
				{ text: 'Sales', value: 'L' },
				{ text: 'Quick Lube', value: 'Q' }
			]
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-information-card-edit {
	@include card;
	padding: $padding-md;
	width: 276px;
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;

	&:hover,
	&:active {
		-o-outline: $focus-outline;
		-moz-outline: $focus-outline;
		outline: $focus-outline;
		outline-offset: $focus-offset;
	}

	&__field-group {
		display: flex;
		justify-content: space-between;

		::v-deep .dropdown .dropdown__input-container {
			min-width: 160px;
		}

		.btn--icon-only {
			font-size: 24px;
		}
	}
}
</style>
